// @flow
import React, {useCallback} from 'react';
import Experiment, {On} from '@homeaway/react-experiment';
import {Waypoint} from '@homeaway/react-unveil';
import {VRBO_RECENTLY_VIEWED_SERP_CAROUSEL} from '../../abacus/experiments';
import PropertyCarousel from '../PropertyCarousel/PropertyCarousel';
import type {PropertyCardListingShape} from '../PropertyCarousel/PropertyCard/PropertyCard';
import {
    triggerPresentedSerpRecentlyViewedCarouselEvent,
    triggerLeadCarouselMabPresentedEvent
} from '../../utils/collectionEdapUtils';
import withLingua from '../withLingua/withLingua';
import type {LinguaProps} from '../withLingua/withLingua';
import {DESKTOP_BREAKPOINTS, MOBILE_BREAKPOINTS} from './breakpoints';

import './RecentlyViewedCarousel.less';

type OwnProps = {
    isMobile: boolean,
    listings: PropertyCardListingShape[],
    mabEventPayloadJson: string,
    messages: any,
    position: string
};

type Props = OwnProps & LinguaProps;

export const RecentlyViewedCarousel = (props: Props) => {
    const {isMobile, messages, listings, position} = props;
    const title = messages.recentlyViewed;
    const breakpoints = isMobile ? MOBILE_BREAKPOINTS : DESKTOP_BREAKPOINTS;

    const triggerCarouselShown = useCallback(() => {
        triggerLeadCarouselMabPresentedEvent();
        triggerPresentedSerpRecentlyViewedCarouselEvent(position);
    }, [position]);

    return (
        <Experiment name={VRBO_RECENTLY_VIEWED_SERP_CAROUSEL}>
            <On>
                <Waypoint
                    onEnter={triggerCarouselShown}
                    useWindowAsScrollParent
                >
                    <PropertyCarousel
                        isMobile={isMobile}
                        title={title}
                        breakpoints={breakpoints}
                        listings={listings}
                    />
                </Waypoint>
            </On>
        </Experiment>
    );
};

export default withLingua({
    namespace: 'traveler/search',
    category: 'messages'
})(RecentlyViewedCarousel);
